import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHttpService } from '@app/core/services/base-http.service';
import { CreateResponseModel } from '@app/core/models/crud/create.model';
import { RaVersion } from './rental-agreements.model';

import {
  RentalAgreementCreateModel,
  RentalAgreementDetailsModel,
  RentalAgreementListModel,
  RentalAgreementUpdateModel
} from './rental-agreements.model';
import { ListRequestModel, ListResponseModel } from '@app/core/models/crud/list.model';

@Injectable({
  providedIn: 'root'
})
export class RentalAgreementsService extends BaseHttpService {
  getAllRentalAgreements(request: ListRequestModel): Observable<ListResponseModel<RentalAgreementListModel>> {
    return this.getPage('/api/rentalAgreement', request);
  }

  getRentalAgreementDetails(uid: string, version: RaVersion = 'latest'): Observable<RentalAgreementDetailsModel> {
    return this.httpClient.get<RentalAgreementDetailsModel>(`${this.baseApiUrl}/api/rentalAgreement/${uid}`, {
      params: version && version !== 'latest' ? { version: version.toString() } : {}
    });
  }

  createRentalAgreementFromReservation(reservationUid: string): Observable<CreateResponseModel> {
    return this.httpClient.post<CreateResponseModel>(`${this.baseApiUrl}/api/rentalAgreement/${reservationUid}`, {});
  }

  createReservation(data: RentalAgreementCreateModel): Observable<CreateResponseModel> {
    return this.create<RentalAgreementCreateModel>('/api/rentalAgreement', data);
  }

  updateRentalAgreement(data: RentalAgreementUpdateModel): Observable<void> {
    return this.update<RentalAgreementUpdateModel>('/api/rentalAgreement', data);
  }

  deleteRentalAgreement(uid: string): Observable<void> {
    return this.delete('/api/rentalAgreement', uid);
  }

  closeRentalAgreement(uid: string): Observable<void> {
    return this.httpClient.put<void>(`${this.baseApiUrl}/api/rentalAgreement/close/${uid}`, {});
  }

  isConfiguredForCountry(countryUid: string): Observable<boolean> {
    return this.httpClient.get<boolean>(
      `${this.baseApiUrl}/api/rentalAgreement/isConfiguredForCountry/${countryUid}`,
      {}
    );
  }
}
